import LinkifyIt from "linkify-it";
import { LinkProps } from "next/link";

import ROUTES from "~/constants/routes";
import { AbsoluteUrl, isAbsoluteUrl } from "~/utils/brandedTypes/absoluteUrl";

const Linkify = new LinkifyIt();

// TODO: Actualize link for mention if it needed
export const getMentionLinkProps = (slug: string): LinkProps => {
  const route = ROUTES.index;

  return {
    href: route.replace("[id]", slug)
  };
};

// TODO: Actualize link for tag
export const getTagLinkProps = (tag: string): LinkProps => {
  const route = ROUTES.index;

  return {
    href: {
      pathname: route,
      query: {
        tag
      }
    }
  };
};

export const getNormalizedAbsoluteUrl = (text: string): AbsoluteUrl | null => {
  const match = Linkify.match(text);

  if (!match || !match.length || !isAbsoluteUrl(match[0].url)) {
    return null;
  }

  return match[0].url;
};
